import { atom } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';

/**
 * Options for diffing.
 */
export const diffOptionsState = atom({
    key: 'diffOptions',
    default: {
        /** Only show the changed pages */
        onlyShowChangedPages: true,
    },
    effects: [
        localStorage.recoilEffect('diffOptions', {
            onlyShowChangedPages: true,
        }),
    ],
});
